import { FC } from "react";
import { useI18n } from "i18n";
import { CompanyAvatar } from "@remo-co/ui-core/src/components/CompanyAvatar";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";

export type EventOrganizerProps = {
  name?: string;
  logoURL?: string;
};

const EventOrganizer: FC<EventOrganizerProps> = ({ name, logoURL }) => {
  const { t } = useI18n(["eventLanding"]);

  return (
    <Container flex column alignItems="flex-start">
      <Container bottom={10}>
        <Typography variant="h5">{t("event.social.organizedBy")}</Typography>
      </Container>
      <Container flex justifyContent="flex-start">
        <Container right={10} fullWidth={false}>
          <CompanyAvatar src={logoURL} size="md" />
        </Container>
        <Typography variant="h5">{name}</Typography>
      </Container>
    </Container>
  );
};

export default EventOrganizer;
